import { useGetUser, useGetUserLocations, useGetUserProfileClinics, useGetUserSalesReps } from '@/hooks/service-hooks/users';
import { useAuthStore, useClinicStore } from '@/store';
import { UserWithAuthData } from '@/types/auth';
import React, { useEffect } from 'react'

interface AuthProviderProps {
  children: React.ReactNode;
}

const AuthProvider = ({ children }: AuthProviderProps) => {
  const user = useAuthStore((state) => state.user?.userInformation);

  const { data: userDetails } = useGetUser('email', user?.email as string);

  const { data: userProfileClinics } = useGetUserProfileClinics(user?.email as string);
  const { data: userSalesReps } = useGetUserSalesReps(user?._id as string, user?.portsAvailable as string);
  const { data: userLocations } = useGetUserLocations(user?._id as string, user?.portsAvailable as string);

  useEffect(() => {
    if (userDetails && userDetails._id) {
      const authStore = useAuthStore.getState();
      const currentUser = useAuthStore.getState().user;
      authStore.setUser(
        currentUser
          ? {
              ...currentUser,
              userInformation: {
                ...currentUser.userInformation,
                ...userDetails,
                isFirstLogin:
                  currentUser.userInformation?.isFirstLogin ??
                  userDetails.isFirstLogin,
              },
            }
          : ({ userInformation: userDetails } as UserWithAuthData),
      );
    }

    if (userProfileClinics && userProfileClinics?.data) {
      const clinicStore = useClinicStore.getState();
      const currentClinics = userProfileClinics.data?.currentClinics || [];
      const availableClinics = userProfileClinics.data?.availableClinics || [];
      const allClinics = [...availableClinics, ...currentClinics];
      clinicStore.setClinics(currentClinics);
      clinicStore.setRawClinics(allClinics);
    }

    if (userSalesReps && userSalesReps?.data) {
      const authStore = useAuthStore.getState();
      authStore.updateUserPreferences({
        currentSalesReps: userSalesReps.data?.currentSalesReps || [],
      });
    }

    if (userLocations && userLocations?.data) {
      const authStore = useAuthStore.getState();
      authStore.updateUserPreferences({
        currentLocations: userLocations.data?.currentLocations || [],
      });
    }
  }, [userDetails, userProfileClinics, userSalesReps, userLocations]);
  
  return (
    <>{children}</>
  )
}

export default AuthProvider
